/* eslint-disable react/no-danger */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { DefaultSeo } from 'next-seo';
import Skeleton from '@mui/material/Skeleton';
import AlarmIcon from '@mui/icons-material/Alarm';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import { Box } from '@mui/material';
import RoomIcon from '@mui/icons-material/Room';
import PropTypes from 'prop-types';
import moment from 'moment';
import { dateTimeVisibilityHandler } from '@app/helpers/dateVisibilityHandler';
import {
  CardMedia,
  Statistics,
  CardContent,
  ContentContainer,
  Card,
  StatisticsItem,
  BlackShade,
  // OrgAvatar,
} from './style';
import { useTranslation } from '../../../../../config/i18n';
import Typography from '../../../../atoms/Typography';
// import Link from '../../../../atoms/Link';
// import Button from '../../../../atoms/Button';

const FormHeader = ({
  opportunity,
  loading,
  // applicationForm
}) => {

  const { t } = useTranslation(['common']);

  const PAGE_SEO = opportunity
    ? {
      title: `Scivenia - Apply to ${opportunity?.title}`,
      description: opportunity?.description,
      openGraph: {
        title: `Scivenia - Apply to ${opportunity?.title}`,
        images: [
          {
            url: opportunity?.logo?.path,
            width: 400,
            height: 400,
          },
        ],
      },
    }
    : {};

  return (
    <>
      {opportunity && <DefaultSeo {...PAGE_SEO} />}
      <Card variant="outlined">
        {/* {loading ? (
          <Skeleton animation="wave" variant="rect" height={250} width="40%" />
        ) : ( */}
          <CardMedia image={opportunity?.logo?.path} title={opportunity?.logo?.name}>
            <BlackShade>
              <CardContent>
                <ContentContainer>
                  <Statistics>
                    {loading ? (
                      <Box marginBottom="0.5rem" width="100%">
                        <Skeleton animation="wave" variant="rect" height={30} width="100%" />
                      </Box>
                    ) : (
                      <StatisticsItem>
                        {dateTimeVisibilityHandler(opportunity, 'overline', '#ffffff')}
                      </StatisticsItem>
                    )}

                    {loading ? (
                      <Skeleton animation="wave" variant="rect" height={40} width="100%" />
                    ) : (
                      <Typography variant="h4" weight="600">
                        {opportunity?.title}
                      </Typography>
                    )}

                    {loading ? (
                      <Skeleton animation="wave" variant="rect" height={30} width="100%" />
                    ) : (
                      <>
                        <StatisticsItem gutter>
                          <Typography variant="body1">
                            {t('by')}{' '} {opportunity?.organisation?.name}
                          </Typography>
                        </StatisticsItem>
                      </>
                    )}

                    {loading ? (
                      <Skeleton animation="wave" variant="rect" height={30} width="100%" />
                    ) : (
                      <>
                        <StatisticsItem gutter>
                          <Typography variant="caption" display="flex">
                            <RoomIcon />
                            {`${
                              // eslint-disable-next-line no-nested-ternary
                              opportunity?.is_virtual
                                ? t('common:virtual_opportunity')
                                : opportunity?.location
                                  ? opportunity?.location?.formatted_address
                                  : t('common:international')
                              }`}
                          </Typography>
                        </StatisticsItem>
                      </>
                    )}

                    {loading ? (
                      <Skeleton animation="wave" variant="rect" height={30} width="100%" />
                    ) : (
                      <>
                        {opportunity?.deadline_date && (
                          <StatisticsItem gutter primary>
                            <Typography variant="caption" display="flex">
                              <AlarmIcon />
                              {`Deadline: ${moment(opportunity?.deadline_date).format(
                                'DD MMM ‘YY HH:mm'
                              )}`}
                            </Typography>
                          </StatisticsItem>
                        )}
                      </>
                    )}

                    {loading ? (
                      <Skeleton animation="wave" variant="rect" height={30} width="100%" />
                    ) : (
                      <>
                        {opportunity?.types && opportunity?.types?.length > 0 && (
                          <StatisticsItem gutter>
                            <Typography variant="caption" display="flex">
                              <LibraryMusicIcon />
                              {opportunity?.event_types?.map((type, index) =>
                                index === 0 ? `${type.name}` : `, ${type.name}`
                              )}
                            </Typography>
                          </StatisticsItem>
                        )}
                      </>
                    )}
                  </Statistics>
                </ContentContainer>
              </CardContent>
            </BlackShade>
          </CardMedia>
        {/* )} */}
      </Card>
    </>
  );
};

FormHeader.propTypes = {
  opportunity: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

FormHeader.defaultProps = {
  loading: false,
};

export default FormHeader;
